import { render, staticRenderFns } from "./CertificateModal.vue?vue&type=template&id=71908b89"
import script from "./CertificateModal.vue?vue&type=script&lang=js"
export * from "./CertificateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports